import { Inject, Injectable } from '@angular/core';
import { DataService } from '../http/dataService';
import { ENV, IEnvironment } from 'env/config';
import { Address } from '../models/address.model';
import { Repository } from './repository';

import { Service } from '../entity';
import { CentralApis } from '../interfaces/internal';
import { Observable } from 'rxjs';
import { Result } from '../index';

@Service({
  api: 'address',
  model: Address,
})
@Injectable({ providedIn: 'root' })
export class AddressService extends Repository<Address> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).activity,
    });
  }

  createFromDTO(item): Address {
    return item;
  }

  query<I>(queryParams?: any): Observable<Result<Address>> {
    return this.loadDataLazily(queryParams);
  }
}
